/**
 * 不要直接使用全局的 zzc 对象，应该import本模块
 */
// eslint-disable-next-line
let zzc = window.zzc;


if (!zzc) {
  zzc = {
    call() {

    }
  };
}

export default zzc;
